export default __webpack_public_path__ + "static/media/linkedin.fa87fa0b.png";